import { type MRT_ColumnDef } from "mantine-react-table-open";
import { type Todo } from "../../../utils/backend-types";
import { TodosListColumnKeys } from "../TodoTable/TodoTable";

export function getLabelColumn(): MRT_ColumnDef<Todo> {
  return {
    id: TodosListColumnKeys.Label,
    accessorFn: (row) => row.label,
    header: "Aufgabe",
    enableCellHoverReveal: true,
    filterVariant: "multi-select",
    enableGrouping: false
  };
}
